module.exports = __webpack_public_path__ + "static/media/Brands_6.a8d2a173.png";